var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNorway(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_284_100829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.938 1.03219C22.3139 1.03266 22.6743 1.1659 22.9401 1.4027C23.2059 1.63949 23.3555 1.96052 23.356 2.2954V20.0015C23.3555 20.3364 23.2059 20.6574 22.9401 20.8942C22.6743 21.131 22.3139 21.2642 21.938 21.2647H2.06201C1.6861 21.2642 1.32572 21.131 1.05991 20.8942C0.7941 20.6574 0.644523 20.3364 0.643994 20.0015V2.2954C0.644523 1.96052 0.7941 1.63949 1.05991 1.4027C1.32572 1.1659 1.6861 1.03266 2.06201 1.03219H21.938ZM21.938 0.458496H2.06201C1.5153 0.458968 0.991126 0.652658 0.604541 0.997039C0.217956 1.34142 0.000529505 1.80837 0 2.2954V20.0015C0.000529505 20.4885 0.217956 20.9555 0.604541 21.2999C0.991126 21.6442 1.5153 21.8379 2.06201 21.8384H21.938C22.4845 21.8375 23.0084 21.6436 23.3949 21.2993C23.7813 20.9551 23.9989 20.4884 24 20.0015V2.2954C23.9995 1.80837 23.782 1.34142 23.3955 0.997039C23.0089 0.652658 22.4847 0.458968 21.938 0.458496Z",
    fill: "#CAB99E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.643921 13.8208V20.0014C0.64445 20.3362 0.794027 20.6573 1.05984 20.8941C1.32565 21.1309 1.68602 21.2641 2.06194 21.2646H5.23191V13.8208H0.643921Z",
    fill: "#E4231A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.23191 1.03223H2.06194C1.68602 1.0327 1.32565 1.16595 1.05984 1.40274C0.794027 1.63953 0.64445 1.96056 0.643921 2.29544V8.47601H5.23191V1.03223Z",
    fill: "#E4231A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9381 1.03223H11.2321V8.47601H23.3561V2.29544C23.3555 1.96056 23.206 1.63953 22.9402 1.40274C22.6743 1.16595 22.314 1.0327 21.9381 1.03223Z",
    fill: "#E4231A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2321 21.2646H21.9381C22.314 21.2641 22.6743 21.1309 22.9402 20.8941C23.206 20.6573 23.3555 20.3362 23.3561 20.0014V13.8208H11.2321V21.2646Z",
    fill: "#E4231A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2321 1.03223H9.73206V9.81225H23.3561V8.47601H11.2321V1.03223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73206 21.2649H11.2321V13.8211H23.3561V12.4849H9.73206V21.2649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.643921 12.4849V13.8211H5.23191V21.2649H6.73191V12.4849H0.643921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.73191 1.03223H5.23191V8.47601H0.643921V9.81225H6.73191V1.03223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73191 1.03223H6.73191V9.81225H0.643921V12.4847H6.73191V21.2648H9.73191V12.4847H23.3559V9.81225H9.73191V1.03223Z",
    fill: "#142B6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_284_100829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21.3799,
    fill: "white",
    transform: "translate(0 0.458496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorway);
export default __webpack_public_path__ + "static/media/Norway.f308a36f798e7fe69139ba0c8097cc62.svg";
export { ForwardRef as ReactComponent };